import { styled } from 'styled-components';

export const FloatingButton = styled.a`
  position: fixed;
  bottom: 24px;
  right: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 55px;
  padding: 16px 30px;
  background: rgb(68, 167, 253);
  color: ${({ theme }) => theme.colors.defaultWhite};
  text-decoration: none;
  font-family: 'Hanken Grotesk', sans-serif;
  font-weight: 600;
  font-size: 16px;
  transition: all 0.3s ease;
  white-space: nowrap;
  box-shadow: 0 4px 15px rgba(68, 167, 253, 0.3);
  z-index: 1000;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
  transform: ${({ $visible }) =>
    $visible ? 'translateY(0)' : 'translateY(20px)'};

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(68, 167, 253, 0.5);
  }

  &:active {
    transform: translateY(1px);
    box-shadow: 0 2px 10px rgba(68, 167, 253, 0.4);
  }

  img {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint?.mobile}) {
    bottom: 16px;
    right: 16px;
    padding: 12px 24px;
    font-size: 14px;
  }
`;
